import { Field } from '@flywire/react-headlessui';
import { useId } from '@flywire/react-headlessui/hooks';
import { LoadingDots } from 'components/ui/LoadingDots/LoadingDots';
import type React from 'react';
import { useTranslations } from 'utils';
import { createMarkup } from 'utils/createMarkup/createMarkup';

interface FileInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  buttonText?: string;
  className?: string;
  hint?: string;
  maxFileSizeInBytes?: number;
}

function FileInput({
  accept = '.png,.jpg,.jpeg,.pdf',
  buttonText,
  className,
  id: customId,
  hint,
  onChange = () => Promise.resolve(true),
  onError = () => {
    // do nothing
  },
  ...rest
}: FileInputProps) {
  const i18n = useTranslations();
  const id = useId(customId);

  const uploadLabel = buttonText || i18n.t('documentCollector.submit');

  return (
    <Field id={id} className={className}>
      <Field.File
        id={`file-${id}`}
        accept={accept}
        className="sr-only"
        onChange={onChange}
        onError={onError}
        data-testid={rest['data-testid'] || 'fileInput'}
        {...rest}
      />
      {hint && (
        <Field.Hint
          className="FileInput-hint"
          dangerouslySetInnerHTML={createMarkup(hint)}
        />
      )}
      <Field.Label
        htmlFor={`file-${id}`}
        className="FileInput-submit"
        data-testid="submitButton"
        render={({ isLoading }) =>
          isLoading ? <LoadingDots /> : <span>{uploadLabel}</span>
        }
      />
    </Field>
  );
}

export { FileInput };
